import { useEffect, useState } from 'react'

export const ALWAYS_VISIBLE_COUNT = 5
export const useCollapsibleList = ({ items, isParentCollapsed, alwaysVisibleCount = ALWAYS_VISIBLE_COUNT }) => {
  const stickyItems = items.slice(0, alwaysVisibleCount)
  const [isListCollapsed, setIsListCollapsed] = useState(true)
  const [collapsibleItems, setCollapsibleItems] = useState(items.slice(alwaysVisibleCount))
  const toggleCollapsedList = () => setIsListCollapsed(s => !s)

  useEffect(() => {
    setCollapsibleItems(items.slice(alwaysVisibleCount))
  }, [alwaysVisibleCount, items])

  useEffect(() => {
    if (!isParentCollapsed) return
    if (!isListCollapsed) setIsListCollapsed(true)
  }, [isParentCollapsed, isListCollapsed, setIsListCollapsed])

  return {
    stickyItems,
    collapsibleItems,
    setCollapsibleItems,
    isListCollapsed,
    setIsListCollapsed,
    toggleCollapsedList
  }
}
